import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';

export default memo(({ data }) => {
  return (
    <>
      <Handle type='target' position={Position.Left} />
      {data.content}
      <Handle type='source' position={Position.Right} />
    </>
  );
});
